import axios from "@/plugins/axios";
import { actionTypes, mutationTypes } from "./types";

export const actions = {
    [actionTypes.getData]({ commit }) {
        commit(mutationTypes.importLogGetDataStart);
        return axios({
            method: "get",
            url: "sql/import-log",
        }).then(
            (data) => {
                commit(mutationTypes.importLogGetDataSuccess, data.data);
            },
            () => {
                commit(mutationTypes.importLogGetDataFailure);
            }
        );
    },
};
